/**
 * Patient-portal sizing for the custom-form canvas. CustomFormCanvas is sized by
 * its consumer (it takes a `renderWidth` prop rather than capping itself), so the
 * portal owns this value. Kept here once and shared by RequestForm and
 * StepCustomForm instead of duplicating the constant + clamp in both.
 */
export const CUSTOM_FORM_MAX_RENDER_W = 800;

/** Clamp the available window width to the portal's custom-form render range. */
export const customFormRenderWidth = (width: number): number =>
  Math.min(Math.max(width - 32, 240), CUSTOM_FORM_MAX_RENDER_W);
